export * from './use-accept-new-terms'
